export const SET_PERSON_INFO = 'loginSetPersonInfo'
